module.exports = __webpack_public_path__ + "img/cantorspace.3489553c.png";